import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectUnitField');

    return {
        UNIT: t('unit'),
        UNIT_IS_REQUIRED: t('unitIsRequired')
    };
};

export default useTranslation;
